import React, { useState, useEffect } from 'react';
import api from '../../api/api';
import ClientLayout from '../../components/AdminLayuot';
import { useNavigate } from 'react-router-dom';

// --- COLORES ADMIN ---
const THEME = {
    primary: '#1F2937',
    secondary: '#3B82F6',
    bg: '#F3F4F6',
    white: '#FFFFFF',
    border: '#E5E7EB'
};

const PRODUCTOS = [
    { value: 'CAFE_AMERICANO', label: 'Café Americano Standard' },
    { value: 'ESPECIALIDAD_CHIAPAS', label: 'Especialidad Chiapas' },
    { value: 'ESPECIALIDAD_GUERRERO', label: 'Especialidad Guerrero' },
    { value: 'DESCAFEINADO', label: 'Descafeinado' },
    { value: 'CAFE_DE_OLLA', label: 'Café de Olla' },
    { value: 'CAFE_EJECUTIVO', label: 'Mezcla Ejecutiva' }
];

function AdminSolicitarPedido() {
    const navigate = useNavigate();
    
    // Estados de Carga
    const [loadingClients, setLoadingClients] = useState(true);
    const [clientes, setClientes] = useState([]);
    
    // Selección
    const [selectedClientId, setSelectedClientId] = useState('');
    const [clientSucursales, setClientSucursales] = useState([]);
    
    // Formulario de Pedido
    const [form, setForm] = useState({
        sucursalId: '',
        tipoProducto: 'CAFE_AMERICANO',
        cantidadGrano: 0,
        cantidadMolido: 0,
        fechaEntrega: '',
        notas: ''
    });

    const [sending, setSending] = useState(false);

    // 1. Cargar lista de Clientes al inicio
    useEffect(() => {
        const fetchClients = async () => {
            const token = localStorage.getItem('token');
            try {
                const { data } = await api.get('/users', { headers: { Authorization: `Bearer ${token}` } });
                // Filtrar solo usuarios con rol Cliente
                const clientsOnly = data.filter(u => u.rol === 'Cliente' && u.isActive);
                setClientes(clientsOnly);
            } catch (error) {
                console.error("Error cargando clientes", error);
            } finally {
                setLoadingClients(false);
            }
        };
        fetchClients();
    }, []);

    // 2. Cuando se selecciona un cliente, cargar sus sucursales
    useEffect(() => {
        if (!selectedClientId) {
            setClientSucursales([]);
            return;
        }

        const fetchClientDetails = async () => {
            const token = localStorage.getItem('token');
            try {
                // Aquí usamos el endpoint que modificamos en el Paso 1
                const { data } = await api.get(`/users/${selectedClientId}`, { 
                    headers: { Authorization: `Bearer ${token}` } 
                });
                
                setClientSucursales(data.sucursales || []);
                
                // Resetear sucursal seleccionada al cambiar de cliente
                setForm(prev => ({ ...prev, sucursalId: '' }));
                
            } catch (error) {
                console.error("Error cargando sucursales del cliente", error);
                alert("No se pudieron cargar las sucursales de este cliente.");
            }
        };
        fetchClientDetails();
    }, [selectedClientId]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!form.sucursalId) return alert("Selecciona una sucursal de destino.");
        if (Number(form.cantidadGrano) + Number(form.cantidadMolido) <= 0) {
            return alert("La cantidad total debe ser mayor a 0.");
        }

        setSending(true);
        const token = localStorage.getItem('token');

        try {
            // Enviamos el pedido. El backend asociará el pedido a la sucursal, 
            // y a través de la sucursal, al cliente dueño.
            await api.post('/pedidos', form, {
                headers: { Authorization: `Bearer ${token}` }
            });

            alert("✅ Pedido creado exitosamente a nombre del cliente.");
            navigate('/admin/pedidos');

        } catch (error) {
            console.error(error);
            alert("Error al crear el pedido. Verifica los datos.");
        } finally {
            setSending(false);
        }
    };

    // Estilos
    const labelStyle = { display: 'block', marginBottom: 5, fontWeight: 'bold', color: THEME.primary, fontSize: 14 };
    const inputStyle = { width: '100%', padding: 10, borderRadius: 8, border: `1px solid ${THEME.border}`, marginBottom: 15 };
    const sectionTitle = { borderBottom: `2px solid ${THEME.secondary}`, paddingBottom: 10, marginBottom: 20, color: THEME.primary };

    if (loadingClients) return <div style={{textAlign:'center', marginTop: 50}}>Cargando directorio de clientes...</div>;

    return (
        <ClientLayout title="Pedido Administrativo">
            <div style={{ maxWidth: 800, margin: '0 auto', background: THEME.white, padding: 30, borderRadius: 12, boxShadow: '0 4px 15px rgba(0,0,0,0.05)' }}>
                
                <h2 style={{ marginTop: 0, color: THEME.primary }}>📝 Crear Pedido para Cliente</h2>
                <p style={{ color: '#666', marginBottom: 30 }}>Esta herramienta genera un pedido oficial a nombre del cliente seleccionado.</p>

                <form onSubmit={handleSubmit}>
                    
                    {/* SECCIÓN 1: SELECCIÓN DE CLIENTE */}
                    <h4 style={sectionTitle}>1. ¿Para quién es el pedido?</h4>
                    
                    <label style={labelStyle}>Buscar Cliente (Empresa / Contacto)</label>
                    <select 
                        style={inputStyle} 
                        value={selectedClientId} 
                        onChange={e => setSelectedClientId(e.target.value)}
                        required
                    >
                        <option value="">-- Selecciona un Cliente --</option>
                        {clientes.map(c => (
                            <option key={c.id} value={c.id}>
                                {c.perfil?.razonSocial || c.username} ({c.perfil?.firstName || 'Sin nombre'})
                            </option>
                        ))}
                    </select>

                    {/* SECCIÓN 2: DETALLES DEL PEDIDO (Solo visible si hay cliente) */}
                    {selectedClientId && (
                        <div style={{ animation: 'fadeIn 0.5s' }}>
                            <h4 style={{ ...sectionTitle, marginTop: 20 }}>2. Detalles de Entrega</h4>

                            {clientSucursales.length === 0 ? (
                                <p style={{ color: 'red', fontStyle: 'italic' }}>⚠️ Este cliente no tiene sucursales registradas. No se puede crear el pedido.</p>
                            ) : (
                                <>
                                    <label style={labelStyle}>Sucursal de Destino</label>
                                    <select 
                                        style={inputStyle} 
                                        value={form.sucursalId} 
                                        onChange={e => setForm({...form, sucursalId: e.target.value})}
                                        required
                                    >
                                        <option value="">-- Selecciona Sucursal --</option>
                                        {clientSucursales.map(s => (
                                            <option key={s.id} value={s.id}>{s.nombre} - {s.direccion}</option>
                                        ))}
                                    </select>

                                    <div style={{ display: 'flex', gap: 20 }}>
                                        <div style={{ flex: 1 }}>
                                            <label style={labelStyle}>Producto</label>
                                            <select 
                                                style={inputStyle} 
                                                value={form.tipoProducto} 
                                                onChange={e => setForm({...form, tipoProducto: e.target.value})}
                                            >
                                                {PRODUCTOS.map(p => <option key={p.value} value={p.value}>{p.label}</option>)}
                                            </select>
                                        </div>
                                        <div style={{ flex: 1 }}>
                                            <label style={labelStyle}>Fecha Entrega</label>
                                            <input 
                                                type="date" 
                                                style={inputStyle} 
                                                value={form.fechaEntrega} 
                                                onChange={e => setForm({...form, fechaEntrega: e.target.value})}
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex', gap: 20 }}>
                                        <div style={{ flex: 1 }}>
                                            <label style={labelStyle}>Kg Molido</label>
                                            <input type="number" min="0" step="0.5" style={inputStyle} value={form.cantidadMolido} onChange={e => setForm({...form, cantidadMolido: e.target.value})} />
                                        </div>
                                        <div style={{ flex: 1 }}>
                                            <label style={labelStyle}>Kg Grano</label>
                                            <input type="number" min="0" step="0.5" style={inputStyle} value={form.cantidadGrano} onChange={e => setForm({...form, cantidadGrano: e.target.value})} />
                                        </div>
                                    </div>

                                    <label style={labelStyle}>Notas (Opcional)</label>
                                    <textarea 
                                        style={{ ...inputStyle, height: 80 }} 
                                        placeholder="Instrucciones especiales..."
                                        value={form.notas} 
                                        onChange={e => setForm({...form, notas: e.target.value})} 
                                    />

                                    <button 
                                        type="submit" 
                                        disabled={sending}
                                        style={{ 
                                            width: '100%', padding: 15, background: THEME.secondary, 
                                            color: 'white', border: 'none', borderRadius: 8, 
                                            fontWeight: 'bold', fontSize: 16, cursor: sending ? 'wait' : 'pointer',
                                            marginTop: 10
                                        }}
                                    >
                                        {sending ? 'Procesando...' : 'Confirmar Pedido Administrativo'}
                                    </button>
                                </>
                            )}
                        </div>
                    )}

                </form>
            </div>
            <style>{`@keyframes fadeIn { from { opacity:0; transform:translateY(10px); } to { opacity:1; transform:translateY(0); } }`}</style>
        </ClientLayout>
    );
}

export default AdminSolicitarPedido;